import {
  SectionSocial as SectionSocialUi,
  SectionSocialProps,
} from '@sbercloud/uikit-product-site-section';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { useLayoutType } from 'src/hooks/useLayoutType';
import { Habr } from 'src/uikit/icons/SocialIcons/HabrIcon';
import { Telegram } from 'src/uikit/icons/SocialIcons/TelegramIcon';
import { VC } from 'src/uikit/icons/SocialIcons/VCIcon';
import { VK } from 'src/uikit/icons/SocialIcons/VKIcon';
import { YouTube } from 'src/uikit/icons/SocialIcons/YouTubeIcon';

const SOCIALS: Omit<SectionSocialProps, 'layoutType'> = {
  title: 'Мы в соцсетях',
  cards: [
    {
      title: 'Telegram-канал Cloud.ru',
      description:
        'Новости компании, лучшие практики внедрения облаков и актуальные IT-тренды',
      href: 'https://t.me/cloudruprovider',
      icon: <Telegram />,
    },
    {
      title: 'Telegram-канал Cloud.ru Tech',
      description:
        'Посты от экспертов Сloud.ru, анонсы IT-конференций, вакансии и стажировки',
      href: 'https://t.me/cloudrutech',
      icon: <Telegram />,
    },
    {
      title: 'VC.ru',
      description: 'Статьи про использование облаков, AI и ML в бизнесе',
      href: 'https://vc.ru/cloud.ru',
      icon: <VC />,
    },
    {
      title: 'VK',
      description: 'Новости, видео и интересные факты про облака',
      href: 'https://vk.com/cloudruprovider',
      icon: <VK />,
    },
    {
      title: 'Habr',
      description:
        'Технические статьи про наши разработки, лайфхаки для инженеров и не только',
      href: 'https://habr.com/ru/companies/cloud_ru/articles/',
      icon: <Habr />,
    },
    {
      title: 'YouTube',
      description: 'Подкасты с IT-экспертами: обсуждаем карьеру и разработку',
      href: 'https://www.youtube.com/@cloudru_team',
      icon: <YouTube />,
    },
  ],
};

export function SectionSocial({
  id,
  title,
  titleAlign,
  backgroundColor,
}: Pick<
  SectionSocialProps,
  'id' | 'title' | 'titleAlign' | 'backgroundColor'
>) {
  const layoutType = useLayoutType();
  const { clickAnalytics } = useAnalytics();

  return (
    <SectionSocialUi
      id={id}
      title={title ?? SOCIALS.title}
      titleAlign={titleAlign}
      backgroundColor={backgroundColor ?? 'neutral-background'}
      cards={SOCIALS.cards.map((card) => ({
        ...card,
        onClick() {
          clickAnalytics({
            action: card.href,
            clickZone: 'body',
            clickElement: 'cardclick',
            clickContent: card.title,
            uniqueId: `benefits-link-${card.title}`,
            transitionType: 'inside-link',
            clickZoneCategory: 'site-body',
            transitionUrl: card.href,
            transitionTypeMetrics: 'internal',
          });
        },
      }))}
      layoutType={layoutType}
    />
  );
}
